import { render, staticRenderFns } from "./companyApplicant.vue?vue&type=template&id=16f6e2ce&scoped=true&"
import script from "./companyApplicant.vue?vue&type=script&lang=js&"
export * from "./companyApplicant.vue?vue&type=script&lang=js&"
import style0 from "./companyApplicant.vue?vue&type=style&index=0&id=16f6e2ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f6e2ce",
  null
  
)

export default component.exports